import type { ReactNode } from 'react';

type ProjectCreationSplitLayoutProps = {
  className?: string;
  leftClassName?: string;
  rightClassName?: string;
  left: ReactNode;
  right: ReactNode;
  rightFooter?: ReactNode;
};

const ProjectCreationSplitLayout = ({
  className = '',
  leftClassName = '',
  rightClassName = '',
  left,
  right,
  rightFooter = null,
}: ProjectCreationSplitLayoutProps) => {
  return (
    <div className={`project-creation-split-layout ${className}`.trim()}>
      <div className={`project-creation-split-layout__left ${leftClassName}`.trim()}>{left}</div>
      <div className={`project-creation-split-layout__right ${rightClassName}`.trim()}>
        <div className="project-creation-split-layout__right-main">{right}</div>
        <div className="project-creation-split-layout__right-footer">{rightFooter}</div>
      </div>
    </div>
  );
};

export default ProjectCreationSplitLayout;
